import { c as _c } from "react/compiler-runtime";
import PremiumPlanWorlds from '@/app/[locale]/(worlds)/profile/[identifier]/components/PremiumPlanWorlds';
import IconArrow from '@/components/assets/icon_arrow_down.svg';
import Loader from '@/components/Loader';
import PremiumPlanPrice from '@/components/PremiumPlanPrice';
import ViverseButton from '@/components/ViverseButton';
import { PAYMENT_TYPE } from '@/constants/market';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useUAContext } from '@/context/UAContext';
import { usePremiumPlanVoucherRooms } from '@/hooks/usePremiumPlansData';
import { PlanSummary } from '@/hooks/usePremiumPlansView';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import { Room } from '@/services/cms';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
type PremiumPlanSectionProps = {
  plans?: PlanSummary[];
  voucherRooms?: Room[];
  activePlanId?: string | null;
  onSelect: (id: string) => void;
  isVoucherRoomsLoading?: boolean;
  canFetchVoucherRooms: boolean;
  sessionKey: string | null;
  onRoomsResult?: (payload: {
    loading: boolean;
    empty: boolean;
    error: boolean;
    voucherId: string | null;
  }) => void;
};
const PremiumPlanSection = t0 => {
  const $ = _c(30);
  const {
    plans,
    activePlanId,
    onSelect,
    canFetchVoucherRooms,
    sessionKey,
    onRoomsResult
  } = t0;
  const t = useTranslations();
  const {
    appConfig
  } = useConfigsContext();
  const {
    isMobile
  } = useUAContext();
  const VIVERSE_MARKET_LINK = appConfig?.links?.viverse_market;
  let t1;
  if ($[0] !== activePlanId || $[1] !== plans) {
    t1 = plans?.find(p => p.id === activePlanId) ?? plans?.[0];
    $[0] = activePlanId;
    $[1] = plans;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const activePlan = t1;
  const {
    voucherRooms,
    isVoucherRoomsLoading,
    isVoucherRoomsEmpty,
    isVoucherRoomsErr
  } = usePremiumPlanVoucherRooms(activePlan?.voucherId, canFetchVoucherRooms, sessionKey ?? undefined);
  let t2;
  if ($[3] !== activePlan || $[4] !== canFetchVoucherRooms || $[5] !== isVoucherRoomsEmpty || $[6] !== isVoucherRoomsErr || $[7] !== isVoucherRoomsLoading || $[8] !== onRoomsResult) {
    t2 = () => {
      const isActivePlan = activePlan?.voucherId && activePlan.voucherId;
      if (!canFetchVoucherRooms || !isActivePlan) {
        return;
      }
      onRoomsResult?.({
        loading: Boolean(isVoucherRoomsLoading),
        empty: Boolean(isVoucherRoomsEmpty),
        error: Boolean(isVoucherRoomsErr),
        voucherId: activePlan?.voucherId || null
      });
    };
    $[3] = activePlan;
    $[4] = canFetchVoucherRooms;
    $[5] = isVoucherRoomsEmpty;
    $[6] = isVoucherRoomsErr;
    $[7] = isVoucherRoomsLoading;
    $[8] = onRoomsResult;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = activePlan?.voucherId;
  let t4;
  if ($[10] !== canFetchVoucherRooms || $[11] !== isVoucherRoomsEmpty || $[12] !== isVoucherRoomsErr || $[13] !== isVoucherRoomsLoading || $[14] !== onRoomsResult || $[15] !== t3) {
    t4 = [canFetchVoucherRooms, isVoucherRoomsLoading, isVoucherRoomsEmpty, isVoucherRoomsErr, t3, onRoomsResult];
    $[10] = canFetchVoucherRooms;
    $[11] = isVoucherRoomsEmpty;
    $[12] = isVoucherRoomsErr;
    $[13] = isVoucherRoomsLoading;
    $[14] = onRoomsResult;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  useEffect(t2, t4);
  let t5;
  if ($[17] !== VIVERSE_MARKET_LINK || $[18] !== activePlan || $[19] !== activePlanId || $[20] !== isMobile || $[21] !== isVoucherRoomsEmpty || $[22] !== isVoucherRoomsLoading || $[23] !== onSelect || $[24] !== plans || $[25] !== t || $[26] !== voucherRooms) {
    t5 = isMobile ? plans?.map(plan => {
      const expanded = activePlanId === plan.id;
      return <div className={cn("mt-4 h-auto w-full rounded-[7px] px-3 py-4", `${expanded ? "bg-[rgba(42,54,73,0.6)]" : "bg-[rgba(0,0,0,0.25)]"}`)} key={plan?.id}><div className="md:pr-8"><div className="flex justify-between"><div className="subheader2-omni-styles flex flex-col pr-4 text-white"><span className="max-w-[318px] pb-1">{plan?.name}</span><span><PremiumPlanPrice currencySymbol={plan.currencySymbol} price={plan.price} originalPrice={plan.originalPrice} discountPercent={plan.discountPercent} suffix={plan.durationUnit && `/${plan.durationUnit}`} /></span></div><IconArrow className={cn("size-[20px] [&>path]:fill-white group-hover:[&>path]:fill-white", `${expanded ? "-rotate-180" : "rotate-0"}`)} onClick={() => onSelect?.(expanded ? "" : plan.id)} aria-expanded={expanded} aria-controls={`plan-rooms-${plan.id}`} /></div><p className="body1-omni-styles pt-2 text-[var(--color-vive-primary-20)]">{plan?.description}</p>{plan?.standardId && <div className="pt-4"><Link target="_blank" href={`${VIVERSE_MARKET_LINK}/checkout?productStandardId=${plan.standardId}`}><ViverseButton className="buttonS-omni-styles px-[20px] py-[12px]">{plan?.paymentType === PAYMENT_TYPE.subscription ? t("premium-plan-section.subscribe") : t("premium-plan-section.purchase")}</ViverseButton></Link></div>}</div>{expanded && <div id={`plan-rooms-${plan.id}`}>{isVoucherRoomsLoading && <div className="flex h-full w-full items-center justify-center py-10"><Loader /></div>}{!isVoucherRoomsLoading && voucherRooms && !isVoucherRoomsEmpty && <><div className="subheader4-omni-styles pt-8 pb-2">{t("premium-plan-dialog.worlds")} ({voucherRooms.length})</div><PremiumPlanWorlds worlds={voucherRooms} /></>}</div>}</div>;
    }) : <div className="dialog-scrollbar h-full min-h-0 w-full overflow-y-auto bg-[rgba(0,0,0,0.25)] pt-6 pr-4 pl-6"><><div className="md:pr-8"><div className="subheader2-omni-styles flex justify-between text-white"><span className="">{activePlan?.name}</span><span>{activePlan && <PremiumPlanPrice currencySymbol={activePlan.currencySymbol} price={activePlan.price} originalPrice={activePlan.originalPrice} discountPercent={activePlan.discountPercent} suffix={activePlan.durationUnit && ` /${activePlan.durationUnit}`} />}</span></div><p className="body2-omni-styles pt-2 text-[var(--color-vive-primary-20)]">{activePlan?.description}</p>{activePlan?.standardId && <div className="pt-4"><Link target="_blank" href={`${VIVERSE_MARKET_LINK}/checkout?productStandardId=${activePlan.standardId}`}><ViverseButton className="buttonM-omni-styles px-[20px] py-[12px]">{activePlan?.paymentType === PAYMENT_TYPE.subscription ? t("premium-plan-section.subscribe") : t("premium-plan-section.purchase")}</ViverseButton></Link></div>}</div>{isVoucherRoomsLoading && <div className="flex h-full w-full items-center justify-center py-10"><Loader /></div>}{!isVoucherRoomsLoading && voucherRooms && !isVoucherRoomsEmpty && <><div className="subheader4-omni-styles pt-10 pb-2">{t("premium-plan-dialog.worlds")}({voucherRooms.length})</div><PremiumPlanWorlds worlds={voucherRooms} /></>}</></div>;
    $[17] = VIVERSE_MARKET_LINK;
    $[18] = activePlan;
    $[19] = activePlanId;
    $[20] = isMobile;
    $[21] = isVoucherRoomsEmpty;
    $[22] = isVoucherRoomsLoading;
    $[23] = onSelect;
    $[24] = plans;
    $[25] = t;
    $[26] = voucherRooms;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== t5) {
    t6 = <>{t5}</>;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  return t6;
};
export default PremiumPlanSection;